import React, { useEffect, useState } from 'react';
import { Button } from './Button';
import { Menu, X } from 'lucide-react';
export function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Product',
    href: '#product'
  }, {
    name: 'Features',
    href: '#features'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/85 backdrop-blur-md border-b border-zinc-200 py-4' : 'bg-transparent py-6'}`} data-id="element-120">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between" data-id="element-121">
        <div className="flex items-center gap-2" data-id="element-122">
          <span className="text-2xl font-bold tracking-tight text-zinc-900" data-id="element-123">
            People<span className="text-peoplecall" data-id="element-124">call</span>
          </span>
          <span className="text-sm font-medium text-zinc-500 border-l border-zinc-300 pl-2 ml-2 tracking-wide mt-1" data-id="element-125">
            Pod
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-8" data-id="element-126">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-zinc-600 hover:text-zinc-900 transition-colors" data-id="element-127">
              {link.name}
            </a>)}
          <Button size="sm" data-id="element-128">Request a Demo</Button>
        </nav>

        <button className="md:hidden text-zinc-900" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-129">
          {mobileMenuOpen ? <X data-id="element-130" /> : <Menu data-id="element-131" />}
        </button>
      </div>

      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-zinc-200 p-6 flex flex-col gap-4" data-id="element-132">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium text-zinc-700 hover:text-zinc-900 transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-133">
              {link.name}
            </a>)}
          <Button className="w-full mt-4" data-id="element-134">Request a Demo</Button>
        </div>}
    </header>;
}